import {Avatar, Box, CircularProgress, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography} from "@mui/material";
import React from "react";

type props = {
  title: string,
  subtitle: string | JSX.Element,
  icon: JSX.Element,
  color?: "primary" | "secondary" | string[] | string
  bgColor: "primary" | "secondary" | string[] | string
  button?: boolean
  onClick?: () => void
  isLoading?: boolean
}

export default function SteddiInfoItem({title, subtitle, icon, color, bgColor, button, onClick, isLoading}: props) {

  function getColor(part: "primary" | "secondary" | string[] | string | undefined) {
    if (part === undefined)
      return "primary.main"
    if (part === "secondary")
      return "secondary.main"
    if (part === "primary")
      return "primary.main"
    return part
  }

  const content = (
    <>
      <ListItemAvatar>
        <Avatar sx={{bgcolor: getColor(bgColor), color: getColor(color)}} variant="rounded">
          {icon}
        </Avatar>
      </ListItemAvatar>
      <ListItemText primary={<Typography><b>{title}</b></Typography>} secondary={<Typography>{subtitle}</Typography>}/>
    </>
  )

  if (button) {
    return (
      <ListItemButton onClick={onClick}>
        {content}
      </ListItemButton>
    )
  }

  function Loader() {
    return (
      <Box sx={{position: "absolute", top: 0, height: "100%", width: "100%", m: "0 -16px", background: "rgba(0, 0, 0, .1)"}} display="flex" alignItems="center" justifyContent="center">
        <CircularProgress size={25}/>
      </Box>
    )
  }

  return (
    <ListItem onClick={onClick}>
      {isLoading && <Loader/>}
      {content}
    </ListItem>
  )
}